import { OrganizationApi } from '../../../api';
import { PolicyDto } from '../../../commonTypes/leaveRequest.types';
import { useContainer } from '../../useContainer';
import { useEffect, useState } from 'react';

const useHttpGetPoliciesByOrganizationOnMount = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [policies, setPolicies] = useState<PolicyDto[]>([]);

    useEffect(() => {
        const { exec, abort } = organizationApi.getPoliciesByOrganizationId({
            onSuccess: res => setPolicies(res.body),
            onError: error => error,
        });
        exec();
        return abort;
    }, []);

    return { policies, setPolicies };
};

export default useHttpGetPoliciesByOrganizationOnMount;
